import fetch from "@/uilts/request";


// 深圳风控报告
export default {
    /**
     * 创建授权书
     */
    async createAuthorization(data) {
        return await fetch.post("ZhengxinDetails/createAuthorization", data)
    },


    /**
     * 获取风控结果
     */

    async queryZxDetailsResult(data){
        return await fetch.post("ZhengxinDetails/queryZxDetailsResult", data)
    },async createCreditfs(data){
        return await fetch.post("ZhengxinDetails/createCreditfs", data)
    }






}




